import { BaseRequest } from './BaseRequest';

export class BuilderRequest extends BaseRequest {
    BucketKey : string | null;
    BotIdentifierDestination : string | null;
    
    constructor(bucketKey: string, clusterName: string, botIdentifier: string | null, botIdentifierDestination: string | null) {
      super();
      this.BucketKey = bucketKey;
      this.ClusterName = clusterName;
      this.BotIdentifier = botIdentifier;
      this.BotIdentifierDestination = botIdentifierDestination;
    }
}